export const sortbyoptions = [
  {
    key: "helpfulCount",
    text: "Helpful",
    value: "helpfulCount",
  },
  {
    key: "createDate",
    text: "Newest",
    value: "createDate",
  },
];

export const sortbyeditoroptions = [
  {
    key: "editor_rate",
    text: "Editor Rate",
    value: "editor_rate",
  },
  {
    key: "createDate",
    text: "Newest",
    value: "createDate",
  },
  {
    key: "helpfulCount",
    text: "Helpful",
    value: "helpfulCount",
  },
];
